import React from 'react';
import { Link } from 'react-router-dom';
import useHttpStatus from '../hooks/useHttpStatus';
import './NotFound.css';

function NotFound() {
  // Set HTTP status to 404
  useHttpStatus(404);
  
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="error-actions">
          <Link to="/dashboard" className="btn-primary">
            Go to Dashboard
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="btn-secondary"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
